<table class="dsn-table-basic">
    <thead>
        <tr>
            <th></th>
            @for (date of tableDates(); track $index) {
                <th>
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <span>{{ date.formatted }}</span>
                        @if (date.scenario) {
                            <span>{{ date.scenario }}</span>
                        }
                    </div>
                </th>
            }
        </tr>
    </thead>
    <tbody>
        @for (row of tableRows(); track $index) {
            <tr>
                <td style="width: 150px; min-width: 150px; white-space: nowrap">
                    <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        class="gap-4"
                    >
                        <span
                            class="chart-legend"
                            [style.background-color]="row.color"
                        ></span>
                        <span>
                            {{ row.serie.props.name }}
                        </span>
                    </div>
                </td>
                @for (result of row.results; track $index) {
                    <td style="min-width: 60px">
                        {{ result.value }}
                    </td>
                }
            </tr>
        }
    </tbody>
</table>
